import { useEffect, useState } from "react";

import { Cookies } from "react-cookie";

import axiosInstance from "../utils/axiosInstance";

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const cookies = new Cookies();

  const token = cookies.get("token");

  useEffect(() => {
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    axiosInstance("/users/me?include=cohortUser,role_id,squads", "get")
      .then((res) => {
        setUser(res.data.data);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [token]);

  return { user, loading };
};
